// extracted by mini-css-extract-plugin
module.exports = {"container":"langs-module--container--2gcBP","lang":"langs-module--lang--viPOI","langText":"langs-module--langText--2TBgw","icon":"langs-module--icon--_HFUy"};